import { useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Loading } from '../components/Loading';
import { getButtonClasses } from '@/components/ui/atoms/Button';
import { generateEventId, fireMetaPixelEvent } from '../services/tracking.service';

export const CallbackPage = () => {
  const { error } = useAuth0();
  const pixelFiredRef = useRef(false);

  useEffect(() => {
    // Auth0 will handle the redirect automatically via onRedirectCallback
    // This page is just a placeholder while the redirect happens

    // Fire Lead pixel event once on successful callback (no error)
    if (!error && !pixelFiredRef.current) {
      pixelFiredRef.current = true;
      try {
        const eventId = generateEventId();
        fireMetaPixelEvent('Lead', {}, eventId);
      } catch {
        // Silent fail — tracking should never break the app
      }
    }
  }, [error]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-marine-50">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-dark-invirtus/90 mb-5">Authentication Error</h1>
          <a
            href="/dashboard"
            className={getButtonClasses(
              'contained',
              'primary',
              'md',
              false,
              'no-underline',
            )}
          >
            Return to Home
          </a>
        </div>
      </div>
    );
  }

  return (
    <Loading />
  );
}; 